var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "border-card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("collectionCenter.particulars"),
                    name: "detail",
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formSearch",
                      attrs: {
                        model: _vm.queryForm,
                        "label-position": "top",
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "selectType" } },
                                [
                                  _c("template", { slot: "label" }, [
                                    _c(
                                      "div",
                                      { staticClass: "selectLabel" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            style: _vm.IsWidth1,
                                            model: {
                                              value:
                                                _vm.queryForm.params.selectType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryForm.params,
                                                  "selectType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryForm.params.selectType",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              key: "1",
                                              attrs: {
                                                label: _vm.$t(
                                                  "newOrder.waybillNumber"
                                                ),
                                                value: 1,
                                              },
                                            }),
                                            _c("el-option", {
                                              key: "2",
                                              attrs: {
                                                label: _vm.$t(
                                                  "GlobalSetObj.ScanNumber"
                                                ),
                                                value: 2,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "newOrder.PreciseSearch1"
                                      ),
                                      rows: 1,
                                      type: "textarea",
                                    },
                                    model: {
                                      value: _vm.queryForm.params.inputValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "inputValue",
                                          $$v
                                        )
                                      },
                                      expression: "queryForm.params.inputValue",
                                    },
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.receiptDate"
                                    ),
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "end-placeholder": _vm.$t(
                                        "operationCenter.endDate"
                                      ),
                                      "start-placeholder": _vm.$t(
                                        "operationCenter.startDate"
                                      ),
                                      "range-separator": "~",
                                      type: "daterange",
                                      "value-format": "yyyy-MM-dd",
                                    },
                                    model: {
                                      value: _vm.timeValue,
                                      callback: function ($$v) {
                                        _vm.timeValue = $$v
                                      },
                                      expression: "timeValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.region"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "placeOrder.pleaseChoose"
                                        ),
                                        clearable: "",
                                        "collapse-tags": "",
                                        filterable: "",
                                        multiple: "",
                                      },
                                      on: { change: _vm.regionChange },
                                      model: {
                                        value:
                                          _vm.queryForm.params.regionIdList,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "regionIdList",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.regionIdList",
                                      },
                                    },
                                    _vm._l(_vm.regionList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label:
                                            item.zhName +
                                            "（" +
                                            item.puName +
                                            "）",
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.stateSite1"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        clearable: "",
                                        "collapse-tags": "",
                                        filterable: "",
                                        multiple: "",
                                      },
                                      on: { change: _vm.stateChange },
                                      model: {
                                        value: _vm.queryForm.params.stateList,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "stateList",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.stateList",
                                      },
                                    },
                                    _vm._l(
                                      _vm.StateList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.label,
                                            value: item.label,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.signSite"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        clearable: "",
                                        "collapse-tags": "",
                                        filterable: "",
                                        multiple: "",
                                      },
                                      model: {
                                        value: _vm.queryForm.params.siteIdList,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "siteIdList",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.siteIdList",
                                      },
                                    },
                                    _vm._l(_vm.siteList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "orderCenterCont.deliveryPerson"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        "remote-method": _vm.getallDriver,
                                        clearable: "",
                                        filterable: "",
                                        multiple: "",
                                        remote: "",
                                        "reserve-keyword": "",
                                      },
                                      on: {
                                        clear: function ($event) {
                                          return _vm.getallDriver("")
                                        },
                                        focus: function ($event) {
                                          return _vm.getallDriver1("")
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.queryForm.params.driverIdList,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "driverIdList",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.driverIdList",
                                      },
                                    },
                                    _vm._l(_vm.userList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.username,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 3 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.picture"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.queryForm.params.photoValid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "photoValid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.photoValid",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("GlobalSetObj.all"),
                                          value: null,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.qualified"
                                          ),
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.unqualified"
                                          ),
                                          value: 0,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 3 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.signature"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        clearable: "",
                                      },
                                      model: {
                                        value:
                                          _vm.queryForm.params.signatureValid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "signatureValid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.signatureValid",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t("GlobalSetObj.all"),
                                          value: null,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.qualified"
                                          ),
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.unqualified"
                                          ),
                                          value: 0,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "27px" },
                              attrs: { span: 12 },
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-search",
                                        size: "small",
                                        type: "primary",
                                      },
                                      on: { click: _vm.enterSearch },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("operationCenter.Procurar")
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-refresh-left",
                                        size: "small",
                                      },
                                      on: { click: _vm.resetForm },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("operationCenter.reset")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-bottom": "10px" },
                                      attrs: {
                                        icon: "el-icon-upload2",
                                        size: "small",
                                        type: "primary",
                                      },
                                      on: { click: _vm.allExportOrder },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("newOrder.export")) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.tableData,
                        "header-cell-style": {
                          background: "#f2f2f2",
                          color: "black",
                        },
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("GlobalSetObj.serial"),
                          align: "center",
                          type: "index",
                          width: "80",
                        },
                      }),
                      _vm._l(_vm.tableHeaderList, function (item, ind) {
                        return _c("el-table-column", {
                          key: ind,
                          attrs: {
                            align: item.align,
                            label: item.label,
                            "min-width": item.width,
                            prop: item.prop,
                            "show-overflow-tooltip": true,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    item.prop === "signatureValName"
                                      ? _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.imageSee(
                                                  scope.row.signatureUrl
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type:
                                                    scope.row.signatureValid ===
                                                    1
                                                      ? "success"
                                                      : "danger",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.signatureValName
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : item.prop === "photoValName"
                                      ? _c(
                                          "div",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.imageSee(
                                                  scope.row.photoUrls
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type:
                                                    scope.row.photoValid === 1
                                                      ? "success"
                                                      : "danger",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.photoValName
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c("div", [
                                          _vm._v(
                                            _vm._s(scope.row[item.prop] || "--")
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "pagination" },
                    [
                      _c("el-pagination", {
                        staticStyle: { margin: "10px 0" },
                        attrs: {
                          "current-page": _vm.queryForm.pageNumber,
                          "page-size": _vm.queryForm.pageSize,
                          "page-sizes": [10, 20, 50, 100],
                          total: _vm.total,
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageNumber", $event)
                          },
                          "update:current-page": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageNumber", $event)
                          },
                          "update:pageSize": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageSize", $event)
                          },
                          "update:page-size": function ($event) {
                            return _vm.$set(_vm.queryForm, "pageSize", $event)
                          },
                          "current-change": _vm.getCurrentTableData,
                          "size-change": _vm.getSizeTableData,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("collectionCenter.statistics"),
                    name: "statistics",
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formSearchStat",
                      attrs: {
                        model: _vm.queryFormStat,
                        "label-position": "top",
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.receiptDate"
                                    ),
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "end-placeholder": _vm.$t(
                                        "operationCenter.endDate"
                                      ),
                                      "start-placeholder": _vm.$t(
                                        "operationCenter.startDate"
                                      ),
                                      "range-separator": "~",
                                      type: "daterange",
                                      "value-format": "yyyy-MM-dd",
                                    },
                                    model: {
                                      value: _vm.timeValueStat,
                                      callback: function ($$v) {
                                        _vm.timeValueStat = $$v
                                      },
                                      expression: "timeValueStat",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.region"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "placeOrder.pleaseChoose"
                                        ),
                                        clearable: "",
                                        "collapse-tags": "",
                                        filterable: "",
                                        multiple: "",
                                      },
                                      on: { change: _vm.regionChangeStat },
                                      model: {
                                        value:
                                          _vm.queryFormStat.params.regionIdList,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryFormStat.params,
                                            "regionIdList",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryFormStat.params.regionIdList",
                                      },
                                    },
                                    _vm._l(_vm.regionList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label:
                                            item.zhName +
                                            "（" +
                                            item.puName +
                                            "）",
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.stateSite1"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        clearable: "",
                                        "collapse-tags": "",
                                        filterable: "",
                                        multiple: "",
                                      },
                                      model: {
                                        value:
                                          _vm.queryFormStat.params.stateList,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryFormStat.params,
                                            "stateList",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryFormStat.params.stateList",
                                      },
                                    },
                                    _vm._l(
                                      _vm.StateListStat,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.label,
                                            value: item.label,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "27px" },
                              attrs: { span: 6 },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    icon: "el-icon-search",
                                    size: "small",
                                    type: "primary",
                                  },
                                  on: { click: _vm.enterSearchStat },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("operationCenter.Procurar")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    icon: "el-icon-refresh-left",
                                    size: "small",
                                  },
                                  on: { click: _vm.resetFormStat },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("operationCenter.reset")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-bottom": "10px",
                                    "margin-left": "10px",
                                  },
                                  attrs: {
                                    icon: "el-icon-upload2",
                                    size: "small",
                                    type: "primary",
                                  },
                                  on: { click: _vm.exportStatData },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("newOrder.export")) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        "cell-class-name": _vm.cellClassName,
                        data: _vm.tableDataStat,
                        "header-cell-style": {
                          background: "#f2f2f2",
                          color: "black",
                        },
                        "row-class-name": _vm.tableRowClassName,
                        "span-method": _vm.objectSpanMethod,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("collectionCenter.receiptDate"),
                          prop: "statDate",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("collectionCenter.region"),
                          prop: "regionName",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("collectionCenter.stateSite1"),
                          prop: "stateName",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("collectionCenter.signTotal"),
                          prop: "totalCount",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(scope.row.totalCount)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("collectionCenter.qualifiedCount"),
                          prop: "qualifiedCount",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(scope.row.qualifiedCount)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("collectionCenter.qualificationRate"),
                          prop: "qualifiedRate",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.calculateQualifiedRate(scope.row)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("collectionCenter.unqualifiedCount"),
                          prop: "unqualifiedCount",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(
                                        scope.row.unqualifiedCount
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: _vm.$t("collectionCenter.unqualifiedRate"),
                          prop: "unqualifiedRate",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.calculateUnqualifiedRate(scope.row)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("imageSeeDialog", { ref: "imageSeeDialogRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }